import { useEntity } from 'app/agriculture/queries/entities/useEntity';
import { useParamsId } from 'app/agriculture/charts/useParamsId';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { HerdsForEntity } from 'app/agriculture/infobox/herds/HerdsForEntity/HerdsForEntity';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';

export function PaddockContent() {
    const id = useParamsId();
    const { paddockType } = useEntity({ entityId: id, entityType: 'Paddock' });

    return (
        <SimpleGrid columns={3}>
            <StatDisplay name="Type" value={paddockType} />
            <HerdsForEntity assetId={id} />
        </SimpleGrid>
    );
}
